import Equipment from "./../equipment";
import Ingredients from "./../ingredients";
import { recipeTypes } from "../recipeTypes";

const Recipe = {
  type: recipeTypes.sauce,

  title: "Chicken liver pate",

  subtitle: "with cream and thyme",

  background: require("../../media/chicken_liver_pate.jpg"),

  details: ["Smooth, rich and good on toast.", "Makes about 4 portions."],

  equipment: [
    Equipment.Frying_pan("large, with lid"),
    Equipment.Spatula(),
    Equipment.Food_processor("or blender"),
    Equipment.Ramekins(),
    Equipment.Cling_film(),
  ],

  optional_equipment: [],

  ingredients: [
    Ingredients.Chicken_livers("225g", "trimmed"),
    Ingredients.Butter("85g", "softened"),
    Ingredients.Garlic(2, "cloves, minced"),
    Ingredients.Shallots(1, "medium, minced"),
    Ingredients.Thyme("1 Tablespoon", "fresh"),
    Ingredients.Salt("1/2 teaspoon"),
    Ingredients.Pepper("1/2 teaspoon"),
    Ingredients.Water(120),
    Ingredients.Heavy_cream("2 Tablespoons"),
  ],

  optional_ingredients: [],

  prep: ["Trim white bits from the livers", "Mince garlic and shallot"],

  prep_time: 15,

  method: [
    "Melt 1 Tablespoon BUTTER",
    "Fry GARLIC and SHALLOT for 1 min",
    "Add LIVERS, THYME, SALT, PEPPER and WATER",
    "Simmer covered on low for 4-8 min",
    "Rest covered for 5 min, then drain",
    "Blend with CREAM and remaining BUTTER until smooth",
    "Cover touching the surface with cling film",
    "Chill 4-6h or overnight",
  ],

  cook_time: 25,
};

export default Recipe;
